import * as React from 'react';
/**
 *
 * Original name: external drive
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=14819%3A11
 *
 */
export const ExternalDriveSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "M25.055 28h20v6h-20v-6Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M81 25a9 9 0 0 0-9-9H22a9 9 0 0 0-9 9v70.25a9 9 0 0 0 9 9h50a9 9 0 0 0 9-9V95h11a9 9 0 0 0 9-9V46h6V28h-3v-5.956H92V28h-3v18h6v40a3 3 0 0 1-3 3H81V25Zm-9-3a3 3 0 0 1 3 3v70.25a3 3 0 0 1-3 3H22a3 3 0 0 1-3-3V25a3 3 0 0 1 3-3h50Zm29 12v6h-6v-6h6Z", fill: "currentColor" })));
